export default __webpack_public_path__ + "static/media/question.dc3a629f.svg";